@let hasQualificationTrainingUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.QualificationTraining);
@let editableQualificationTrainings =
  (editableQualificationTrainings$ | async) || [];
<button
  nz-button
  nzType="default"
  (click)="showTrainingQualificationBulkEditDrawer()"
  [disabled]="
    !hasQualificationTrainingUpdatePermission ||
    !editableQualificationTrainings?.length
  "
  nz-tooltip
  [nzTooltipTitle]="'general.no_permissions' | translate"
  [nzTooltipTrigger]="
    !hasQualificationTrainingUpdatePermission ? 'hover' : null
  "
>
  {{ 'general.edit' | translate }}
  @if (editableQualificationTrainings?.length) {
    ({{ editableQualificationTrainings?.length }})
  }
</button>
